import { ENVIRONMENT_LINK_ENDPOINTS_NAMES } from '@constants/common/environmentLinkEndpointNames';
import { HEADER_LINKS_TYPES, EXTRA_ACTIONS } from '../constants/headerLinkTypes';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';
import { ssapModalTypes as MODAL_TYPES } from '@constants/ssap/modals/ssapModalTypes';
import { IEX_STATE_CODES } from '@constants/configs/states';
import { onLogout } from '@utils/localStorage/sessionStorageUtils';

export const idahoHeaderLogo = {
    link: true
};
export const idaho = {
    linkDetails: [
        {
            name: 'language',
            className: ['usa-nav__primary-item gi-main__nav__primary-item link__language'],
            linkClassName:['gi-main__nav__primary-item__link'],
            text: 'header.lang',
            path: '#',
            type: HEADER_LINKS_TYPES.LANGUAGE_SWITCH,
            visible: environment => environment.anonymous || environment.impersonation || environment.user && environment.user.role === ALL_USER_ROLES.INDIVIDUAL
        },
        {
            name: 'login',
            text: 'header.login',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.LOGIN,
            type: HEADER_LINKS_TYPES.LINK,
            visible: environment => environment.anonymous
        },
        {
            name: 'home',
            text: 'header.home',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link'],
            symbols: ['home'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.DASHBOARD,
            type: HEADER_LINKS_TYPES.ICON,
            visible: (environment, currentPath, telexEnabled, errorStatus) => !environment.anonymous && !errorStatus,
            urlReplacements: [ENVIRONMENT_LINK_ENDPOINTS_NAMES.PHONE]
        },
        {
            name: 'secured-mail',
            text: 'header.inbox',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link secured-mail'],
            symbols: ['envelope'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.UNREAD_MESSAGES,
            type: HEADER_LINKS_TYPES.ICON,
            visible: (environment, currentPath, telexEnabled, errorStatus) => !environment.anonymous && !errorStatus,
            showUnreadMessage: true
        },
        // getAssistance for anonymous Flow
        {
            name: 'get-assistance',
            text: 'header.getAssistance',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            btnClassName: ['dropdown__pos--01'],
            symbol: 'info-circle',
            ariaClassName: ['extended-nav-section-one'],
            path: '#',
            type: HEADER_LINKS_TYPES.DROPDOWN,
            statesHasFeature: environment => environment.stateCode === IEX_STATE_CODES.ID,
            visible : environment => environment.anonymous,
            dropdown: [
                {
                    name: 'find-assistance',
                    text: 'header.getAssistance.localAssistance',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:[''],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.ASSISTANCE,
                    type: HEADER_LINKS_TYPES.LINK,
                    additionalProperties: {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    }
                },
                {
                    name: 'faq',
                    text: 'header.getAssistance.help',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:[''],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.HELP,
                    type: HEADER_LINKS_TYPES.LINK,
                    additionalProperties: {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    }
                },
                {
                    name: 'contact',
                    text: 'header.getAssistance.contactUs',
                    text_2: 'header.getAssistance.contactUs_number',
                    hasTextWithIcon: true,
                    className: ['usa-nav__submenu-item cursor-pointer'],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.PHONE,
                    symbol: 'phone',
                    symbolClassName: 'phone fa-flip-horizontal',
                    symbolPosition: 'middle',
                    type: HEADER_LINKS_TYPES.LINKS_AND_ICONS
                }
            ]
        },
        // getAssistance for non-anonymous Flow
        {
            name: 'get-assistance',
            text: 'header.getAssistance',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            btnClassName: ['dropdown__pos--01'],
            symbol: 'info-circle',
            ariaClassName: ['extended-nav-section-one'],
            path: '#',
            type: HEADER_LINKS_TYPES.DROPDOWN,
            statesHasFeature: environment => environment.stateCode === IEX_STATE_CODES.ID,
            visible : environment => (environment.user && [
                ALL_USER_ROLES.INDIVIDUAL,
                ALL_USER_ROLES.BROKER,
                ALL_USER_ROLES.ISSUER_REPRESENTATIVE,
                ALL_USER_ROLES.ADMIN,
                ALL_USER_ROLES.ASSISTER].some(
                role => role === environment.user.role )
                || environment.impersonation || !environment.anonymous),
            dropdown: [
                {
                    name: 'find-assistance',
                    text: 'header.getAssistance.localAssistance',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:[''],
                    path: '#',
                    type: HEADER_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL
                },
                {
                    name: 'faq',
                    text: 'header.getAssistance.help',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:[''],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.HELP,
                    type: HEADER_LINKS_TYPES.LINK,
                    additionalProperties: {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    }
                },
                {
                    name: 'contact',
                    text: 'header.getAssistance.contactUs',
                    text_2: 'header.getAssistance.contactUs_number',
                    hasTextWithIcon: true,
                    className: ['usa-nav__submenu-item cursor-pointer'],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.PHONE,
                    symbol: 'phone',
                    symbolClassName: 'phone fa-flip-horizontal',
                    symbolPosition: 'middle',
                    type: HEADER_LINKS_TYPES.LINKS_AND_ICONS
                }
            ]
        },
        {
            name: 'my-authentication',
            text: 'header.myAccount',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            btnClassName: ['dropdown__pos--02'],
            ariaClassName: ['extended-nav-section-two'],
            symbol: 'user',
            path: '#',
            type: HEADER_LINKS_TYPES.DROPDOWN,
            statesHasFeature: environment => [IEX_STATE_CODES.NV, IEX_STATE_CODES.NJ, IEX_STATE_CODES.PA, IEX_STATE_CODES.ID].some( state => state === environment.stateCode ),
            visible: (environment, currentPath, telexEnabled, errorStatus) => (!environment.anonymous && !errorStatus),
            dropdown: [
                {
                    name: 'authentication-settings',
                    text: 'header.myAccount.accountSettings',
                    className: ['usa-nav__submenu-item'],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.SETTINGS,
                    type: HEADER_LINKS_TYPES.LINK

                },
                {
                    name: 'dashboard',
                    text: 'header.myAccount.dashboard',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:[''],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.DASHBOARD,
                    type: HEADER_LINKS_TYPES.LINK
                },
                {
                    name: 'logout',
                    text: 'header.myAccount.logout',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:[],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.LOGOUT,
                    type: HEADER_LINKS_TYPES.LINK,
                    extraAction: EXTRA_ACTIONS.CHECK_SSAP,
                    beforeClick: onLogout
                }
            ]
        }
    ]
};